import "./App.css";
import React, {useState} from 'react';
import RoutingPage from "./RoutingPage";
import { AppContext } from "./context.js";


function App() {
  const [fieldName, setFieldName] = useState({name:'thi is name'});
  const [videoData,setVideoData]=useState([])
  const [student,setstudent]=useState();
  const [stu,setstu]=useState();


  return (
    <>
      <div className="App">
        <AppContext.Provider value={{ fieldName,setFieldName,videoData,setVideoData,student,setstudent,stu,setstu}}>
          <RoutingPage />
        </AppContext.Provider>
      </div>
    </>
  );
}

export default App;
